import { apiFetch } from '@shared/api/http'
import {
  CoproductionInviteSchema,
  CreateCoproductionInputSchema,
  UpdateCoproductionPercentageInputSchema,
  planCoproductionSync,
} from './coproduction.contract'
import type {
  CoproducerDraft,
  CoproductionInvite,
  CreateCoproductionInput,
  UpdateCoproductionPercentageInput,
} from './coproduction.contract'

async function createCoproduction(input: CreateCoproductionInput): Promise<CoproductionInvite> {
  const body = CreateCoproductionInputSchema.parse(input)
  const data = await apiFetch<unknown>(`/admin/products/${body.productId}/coproduction`, {
    method: 'POST',
    body: { coProducerEmail: body.coProducerEmail, percentage: body.percentage },
  })
  return CoproductionInviteSchema.parse(data)
}

async function updateCoproductionPercentage(
  id: string,
  input: UpdateCoproductionPercentageInput,
): Promise<CoproductionInvite> {
  const body = UpdateCoproductionPercentageInputSchema.parse(input)
  const data = await apiFetch<unknown>(`/admin/coproductions/${id}/percentage`, {
    method: 'PATCH',
    body,
  })
  return CoproductionInviteSchema.parse(data)
}

async function removeCoproduction(id: string): Promise<void> {
  await apiFetch<unknown>(`/admin/coproductions/${id}`, { method: 'DELETE' })
}

export type CoproductionSyncResult =
  | { changed: false }
  | { changed: true; invite: CoproductionInvite | null }

export async function syncCoproduction(
  productId: string,
  next: CoproducerDraft | undefined,
  previous: CoproducerDraft | undefined,
): Promise<CoproductionSyncResult> {
  const action = planCoproductionSync(next, previous)

  switch (action.kind) {
    case 'noop':
      return { changed: false }
    case 'create':
      return {
        changed: true,
        invite: await createCoproduction({
          productId,
          coProducerEmail: action.coProducerEmail,
          percentage: action.percentage,
        }),
      }
    case 'update':
      return {
        changed: true,
        invite: await updateCoproductionPercentage(action.id, {
          percentage: action.percentage,
        }),
      }
    case 'replace':
      await removeCoproduction(action.removeId)
      return {
        changed: true,
        invite: await createCoproduction({
          productId,
          coProducerEmail: action.coProducerEmail,
          percentage: action.percentage,
        }),
      }
    case 'remove':
      await removeCoproduction(action.id)
      return { changed: true, invite: null }
  }
}
